import { useCallback, useContext, useState } from "react";
import { SuccessAlertContext } from "App";
import type { Severity } from "../../../type/index";
import productEditDataApi from "../api/productEditDataApi";
import type { JoyfulEditItem, SaveProductSettingParams } from "../types";

/**
 * ジョイフル取扱商品登録、更新、削除のhooks
 */
export default function useProductSetting(defaultCompanyCd: string) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const { showAlert } = useContext(SuccessAlertContext);

  // 登録
  const registerProduct = useCallback(
    async (params: Omit<SaveProductSettingParams, "operation">) => {
      const body: SaveProductSettingParams = {
        operation: 0,
        ...params,
      };

      setIsRegistering(true);

      try {
        const status = await productEditDataApi(body);
        // return status;
      } catch (err) {
        console.error(err);
        showAlert("登録に失敗しました", "error" as Severity);
        // throw err;
      } finally {
        setIsRegistering(false);
      }
    },
    [showAlert],
  );

  // 更新
  const updateProduct = useCallback(
    async (params: Omit<SaveProductSettingParams, "operation">) => {
      const body: SaveProductSettingParams = {
        operation: 1,
        ...params,
      };

      setIsUpdating(true);

      try {
        const status = await productEditDataApi(body);
        // return status;
      } catch (err) {
        console.error(err);
        showAlert("更新に失敗しました", "error" as Severity);
        // throw err;
      } finally {
        setIsUpdating(false);
      }
    },
    [showAlert],
  );

  // 削除
  const deleteProduct = useCallback(
    async (itemCds: string[]) => {
      const items: JoyfulEditItem[] = itemCds.map((item_cd) => ({
        item_cd,
      }));

      setIsDeleting(true);

      try {
        const seen = new Set<string>();
        const result = await productEditDataApi({
          operation: 9,
          company_cd: defaultCompanyCd,
          managed_items: items.filter(it => {
            if (seen.has(it.item_cd)) return false;
            seen.add(it.item_cd);
            return true;
          }),
        });
        // return result;
      } catch (err) {
        console.error(err);
        showAlert("削除に失敗しました。", "error" as Severity);
        // throw err;
      } finally {
        setIsDeleting(false);
      }
    },
    [productEditDataApi, defaultCompanyCd, showAlert],
  );

  return { isRegistering, isUpdating, isDeleting, registerProduct, updateProduct, deleteProduct };
}
